/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {ServerObject} from "../models/server-object";
import {ServerObjectService} from "../services/server-object.service";
import { Input, Injectable } from "@angular/core";
import {Resolve, ActivatedRouteSnapshot, RouterStateSnapshot} from "@angular/router";
import {PAGING_ITEMS_PER_PAGE} from "../app-constants";
import { PagedResults } from "app/models/paged-results";

@Injectable()
//@Input() KHT - using the @Input() tag breaks certain resolvers after Angular 12 update
export class ServerObjectsPagingResolver implements Resolve<PagedResults<ServerObject>> {

  constructor(
    private mServerObjectService: ServerObjectService
  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<PagedResults<ServerObject>> {
    try {
      return await this.mServerObjectService.getAllServerObjectsForPaging(0, PAGING_ITEMS_PER_PAGE, 'ASC', "");
    } catch (error) {
      console.error("Problem resolving Server Objects... Error: " + error, error);
    }
  }

}
